import { useEffect, useRef, useState } from 'react';

const TOTAL_DURATION = 500; // ms — fixed total regardless of step count

export function useAnimatedStepperIndex(visualActiveStepIndex: number) {
  const [animatedIndex, setAnimatedIndex] = useState(visualActiveStepIndex);
  const prevIndexRef = useRef(visualActiveStepIndex);
  const timeoutsRef = useRef<ReturnType<typeof setTimeout>[]>([]);

  useEffect(() => {
    const prev = prevIndexRef.current;
    const target = visualActiveStepIndex;
    prevIndexRef.current = target;

    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];

    if (target === prev) return;

    const steps = Math.abs(target - prev);
    const direction = target > prev ? 1 : -1;
    const stepDelay = TOTAL_DURATION / steps; // proportional — 1 step=500ms, 5 steps=100ms each

    for (let i = 1; i <= steps; i++) {
      const delay = (i - 1) * stepDelay; // first fires at 0ms (immediate)
      const t = setTimeout(() => {
        setAnimatedIndex(prev + direction * i);
      }, delay);
      timeoutsRef.current.push(t);
    }

    return () => {
      timeoutsRef.current.forEach(clearTimeout);
    };
  }, [visualActiveStepIndex]);

  return animatedIndex;
}
